import { ALLOWED_JUSTIFIES, ALLOWED_ROW_ALIGNS, ALLOWED_SPACING_TOKENS, sanitizeAllowedString, sanitizeBoolean, sanitizePositiveInteger } from './helpers';
export function sanitizeRow(el, sanitizeElement) {
  if (!Array.isArray(el.children)) {
    return null;
  }
  const children = el.children.map(sanitizeElement).filter(child => child !== null);
  if (children.length === 0) {
    return null;
  }
  return {
    type: 'Row',
    children,
    gap: sanitizeAllowedString(el.gap, ALLOWED_SPACING_TOKENS),
    justify: sanitizeAllowedString(el.justify, ALLOWED_JUSTIFIES),
    align: sanitizeAllowedString(el.align, ALLOWED_ROW_ALIGNS),
    wrap: sanitizeBoolean(el.wrap),
    breakAt: sanitizePositiveInteger(el.breakAt)
  };
}